/* tslint:disable */
/* eslint-disable */
/**
 * Presentation API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GeneratePresentationPdfResponseDto
 */
export interface GeneratePresentationPdfResponseDto {
    /**
     * 
     * @type {string}
     * @memberof GeneratePresentationPdfResponseDto
     */
    url: string;
}

/**
 * Check if a given object implements the GeneratePresentationPdfResponseDto interface.
 */
export function instanceOfGeneratePresentationPdfResponseDto(value: object): value is GeneratePresentationPdfResponseDto {
    if (!('url' in value) || value['url'] === undefined) return false;
    return true;
}

export function GeneratePresentationPdfResponseDtoFromJSON(json: any): GeneratePresentationPdfResponseDto {
    return GeneratePresentationPdfResponseDtoFromJSONTyped(json, false);
}

export function GeneratePresentationPdfResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GeneratePresentationPdfResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'url': json['url'],
    };
}

export function GeneratePresentationPdfResponseDtoToJSON(json: any): GeneratePresentationPdfResponseDto {
    return GeneratePresentationPdfResponseDtoToJSONTyped(json, false);
}

export function GeneratePresentationPdfResponseDtoToJSONTyped(value?: GeneratePresentationPdfResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'url': value['url'],
    };
}

